<div class="grid p-fluid">
  <form [formGroup]="resultForm" class="col-12 lg:col-12 md:col-12 form-group" novalidate>
    <div class="p-fluid p-formgrid grid">
      <div class="p-field col-12 md:col-6">
        <span class="p-float-label size_cent form-margin">
          <input formControlName="name" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Cm_Name' | translate}} *</label>
        </span>
        <span class="p-float-label size_cent form-margin">
          <input formControlName="label" class="p-inputtext size_cent" pInputText type="text" />
          <label>{{'Cm_Label' | translate}} *</label>
        </span>
        <span class="p-float-label size_cent form-margin">
          <input formControlName="menuorder" class="p-inputtext size_cent" pInputText type="number" min="0" />
          <label>{{'Cm_Order' | translate}} *</label>
        </span>
        <p-pickList [source]="screenInternalList" [target]="screenSelect" sourceHeader="{{'Cm_menu_N' | translate}}" targetHeader="{{'Cm_menu_N' | translate}}" [responsive]="true" filterBy="label"
          [showSourceControls]="false" [showTargetControls]="false" (onMoveToTarget)="moveToTarget($event)" (onMoveToSource)="moveToSource($event)"
          dragdrop="true" sourceFilterPlaceholder="{{'Filter_A' | translate}}" targetFilterPlaceholder="{{'Filter_A' | translate}}" [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}">
          <ng-template let-screen pTemplate="item">
            <div>
              <div style="font-size:14px;float:left">{{screen.label}}</div>
            </div>
          </ng-template>
        </p-pickList>

      </div>
      <div class="p-field col-12 md:col-6">
        <div>{{'Desc' | translate}}</div>
        <textarea formControlName="desc" rows="4" cols="57" pInputTextarea></textarea>
      </div>
    </div>
  </form>
</div>

<div class="col-12 lg:col-12 md:col-12 align-right">
  @if (resultForm.controls['id'].value) {
    <button
      (click)="deleteItem()"
      class="p-button-danger p-button p-component p-button-text-only blockBottom margin"
      >
      {{'Delete' | translate}}
    </button>
  }
  <button
    (click)="cancel()"
    type="button"
    class="p-button-primary p-button-outlined p-button p-component p-button-text-only btn-square margin"
    >
    {{'Cancel' | translate}}
  </button>
  <button
    (click)="validate()"
    type="button"
    class="p-button p-component p-button-text-only btn-square margin"
    >
    {{'Valid' | translate}}
  </button>
</div>
